<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1842_508)">
      <path
        d="M9.4942 8.23642L7.54222 6.77244V3.79027C7.54222 3.49042 7.29984 3.24805 6.99999 3.24805C6.70014 3.24805 6.45776 3.49042 6.45776 3.79027V7.04358C6.45776 7.21437 6.53802 7.37542 6.67465 7.47736L8.84351 9.10401C8.9411 9.17721 9.05498 9.21246 9.16829 9.21246C9.33367 9.21246 9.49634 9.13816 9.60262 8.99502C9.78268 8.75587 9.73387 8.41591 9.4942 8.23642Z"
        fill="#FFE400"
      />
      <path
        d="M7 0C3.13996 0 0 3.13996 0 7C0 10.86 3.13996 14 7 14C10.86 14 14 10.86 14 7C14 3.13996 10.86 0 7 0ZM7 12.9156C3.73857 12.9156 1.08443 10.2614 1.08443 7C1.08443 3.73857 3.73857 1.08443 7 1.08443C10.262 1.08443 12.9156 3.73857 12.9156 7C12.9156 10.2614 10.2614 12.9156 7 12.9156Z"
        fill="#FFE400"
      />
    </g>
    <defs>
      <clipPath id="clip0_1842_508">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
export default {};
</script>
